import { LockOutlined } from '@ant-design/icons';
import { Table as ATable, Tooltip, Typography } from 'antd';
import colors from '../../../constants/ColourConstants';
import moment from 'moment';

export default function AuditLogTable({
  data,
  loading,
  title,
  handleSort,
  sortField,
}) {
  const { Text } = Typography;

  const columns = [
    {
      title: 'ID',
      dataIndex: 'Id',
      key: 'Id',
      width: 155,
      render: (value, row) => {
        const { isLocked } = row;
        return (
          <Tooltip
            title={
              <>
                {value} {isLocked && <LockOutlined />}
              </>
            }
          >
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
              {isLocked && (
                <LockOutlined
                  style={{
                    marginLeft: 8,
                    fontSize: '16px',
                    color: colors.colorIcon,
                  }}
                />
              )}
            </Text>
          </Tooltip>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'Id' ? sortField?.order : null,
    },
    {
      title: 'Field',
      dataIndex: 'fieldChanged',
      key: 'fieldChanged',
      width: 155,
      render: (value) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'Old',
      dataIndex: 'oldValue',
      key: 'oldValue',
      width: 155,
      render: (value) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'New',
      dataIndex: 'newValue',
      key: 'newValue',
      width: 155,
      render: (value) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'Date & Time Modified',
      dataIndex: 'recordCreatedDate',
      key: 'recordCreatedDate',
      width: 155,
      render: (value) => {
        const date = value.split('T');
        const time = moment(date[1], 'HH:mm:ss.SSSSSS').format('hh:mm:ss A');
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {`${date[0]} | ${time}`}
            </Text>
          </Tooltip>
        );
      },
      sorter: true,
      sortOrder:
        sortField?.field === 'recordCreatedDate' ? sortField?.order : null,
    },
    {
      title: 'Modified  By',
      dataIndex: 'createdById',
      key: 'createdById',
      width: 155,
      render: (value) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
            </Text>
          </Tooltip>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'createdById' ? sortField?.order : null,
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    handleSort({ field, order });
  };

  return (
    <>
      <div style={{ margin: '24px 0' }}>
        <ATable
          title={title}
          loading={loading}
          onFilter
          style={{ height: '100%' }}
          columns={columns}
          dataSource={data}
          pagination={false}
          onChange={handleTableChange}
          bordered
          scroll={{
            y: 'calc(100vh - 370px)',
          }}
        />
      </div>
    </>
  );
}
